import axios from "axios";
import { newApiBaseUrl } from "../../axiosInstance";
import * as actionType from "../store/action";
import { setPreload } from "../server/CartsOpen";
import { useSelector } from "react-redux";

export const getAllCategory = (stationId, slug, depth) => {
  return (dispatch) => {
    const params = {
      branch: stationId,
      depth: depth,
      includeFamilies: true,
      includeInactive: true,
      slug: slug,
    };

    axios
      .get(`${newApiBaseUrl}/catalog/tree`, {
        params,
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
        },
      })
      .then((x) => {
        const responseData = Array.isArray(x.data) ? x.data : [];

        if (slug) {
          console.log("Updating category branch for slug:", slug);
          const inferredParentId =
            responseData.length > 0 ? responseData[0].parentId : null;

          dispatch({
            type: actionType.UPDATE_CATEGORY_BRANCH,
            payload: { items: responseData, parentId: inferredParentId },
          });
        } else {
          dispatch({
            type: actionType.SET_ALL_CATEGORY,
            payload: responseData,
          });
        }
      })
      .catch((err) => console.error("Error fetching categories:", err));
  };
};
export const getCategoriesBySlug = (stationId, slug) => {
  return (dispatch) => {
    const params = {
      branch: stationId,
      depth: 10,
    };
    axios
      .get(`${newApiBaseUrl}/categories/${slug}`, {
        params,
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
        },
      })
      .then((x) => {
        if (!Array.isArray(x.data)) {
          x.data = [];
        }
        dispatch({ type: actionType.SET_ALL_CATEGORY, payload: x.data });
      });
  };
};

export const CategoryAdd = (slug, data, stationId) => {
  return (dispatch) => {
    dispatch(setPreload(true));
    axios
      .put(`${newApiBaseUrl}/admin/categories/${slug}`, data, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
        },
      })
      .then((x) => {
        dispatch({ type: actionType.ADD_CATEGORY, payload: data });
        dispatch(getAllCategory(stationId));
      })

      .catch((error) => {
        console.error(error.response || error.message);
      })
      .finally(() => {
        dispatch(setPreload(false));
      });
  };
};

export const CategoryDelete = (categorySlug, stationId) => {
  return (dispatch) => {
    dispatch(setPreload(true));
    axios
      .delete(
        `${newApiBaseUrl}/admin/categories/${categorySlug}?branch=${stationId}`,
        {
          headers: {
            Authorization: `bearer ${localStorage.jwtToken}`,
            "X-Tenant": "hamazon",
          },
        }
      )
      .then((_x) => {
        dispatch({ type: actionType.DELETE_CATEGORY, payload: categorySlug });
        dispatch(getAllCategory(stationId));
      })
      .catch((error) => {
        console.error("Error deleting category:", error);
      })
      .finally(() => dispatch(setPreload(false)));
  };
};

export const CategoryUpdate = (data, stationId) => {
  return async (dispatch) => {
    dispatch(setPreload(true));
    const slug = data.slug;
    const paramName = data.Title;
    const payload = {
      branch: stationId,
    };
    payload[paramName] = data.value;
    if (paramName === "position" && data.rank) {
      payload.rank = data.rank;
    }
    if (data.Mkt) {
      payload.Mkt = data.Mkt;
    }
    try {
      const response = await axios.patch(
        `${newApiBaseUrl}/admin/categories/${slug}`,
        payload,
        {
          headers: {
            Authorization: `bearer ${localStorage.jwtToken}`,
            "X-Tenant": "hamazon",
          },
        }
      );
      dispatch(getAllCategory(stationId));
      dispatch(setPreload(false));
      return response.data;
    } catch (error) {
      console.error(error.response?.data || error);
      dispatch(setPreload(false));
      throw error;
    }
  };
};

export const CategoryMove = (
  childSlug,
  newParentSlug,
  stationId,
  position,
  relativeSlug = null
) => {
  return async (dispatch) => {
    dispatch(setPreload(true));
    let payload = {
      branch: stationId,
      newParentSlug: newParentSlug,
      position: position,
    };
    console.log("CategoryMove Payload (Fixed):", payload);
    try {
      const response = await axios.post(
        `${newApiBaseUrl}/admin/categories/${childSlug}/move`,
        payload,
        {
          headers: {
            Authorization: `bearer ${localStorage.jwtToken}`,
            "X-Tenant": "hamazon",
          },
        }
      );

      dispatch(getAllCategory(stationId));
      return response.data;
    } catch (error) {
      console.error("Error moving category:", error.response?.data || error);
      throw error;
    } finally {
      dispatch(setPreload(false));
    }
  };
};
export const CategorySetImg = (data) => (dispatch) =>
  dispatch({ type: actionType.EDIT_CATEGORY, payload: data });

export const toggleExpandCardAction = (id) => ({
  type: actionType.TOGGLE_EXPAND_CARD,
  payload: id,
});

export const resetExpandedCards = () => ({
  type: actionType.RESET_EXPANDED_CARDS,
});

export const getBySlug = async (branch, slug, options = {}) => {
  return axios
    .get(`${newApiBaseUrl}/categories/${slug}`, {
      params: {
        branch: branch,
        fields:
          "gtin,name,variant,status,brand_name,user_company,media,description,kosher_supervision,weight_details,weight_jump",
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
      ...options,
    })
    .then((response) => response.data)
    .catch((error) => {
      if (error.name === "CanceledError") {
        console.log("Request canceled:", slug);
      } else {
        console.error("Error fetching products by category:", error);
      }
    });
};